import { render, staticRenderFns } from "./ossupload.vue?vue&type=template&id=48f5f54c&scoped=true"
import script from "./ossupload.vue?vue&type=script&lang=js"
export * from "./ossupload.vue?vue&type=script&lang=js"
import style0 from "./ossupload.vue?vue&type=style&index=0&id=48f5f54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f5f54c",
  null
  
)

export default component.exports